<template>
  <div>

    <topNav v-on:listenClassify = "getClassfiy"></topNav>
    <banner></banner>
    <mune></mune>
    <!--todayGrapBuy></todayGrapBuy-->
    <specialArea></specialArea>
    <couponGoodsList :parentCat ="parentCat" ref='offsetTopEle' ></couponGoodsList>
  </div>
</template>

<script type = "text/ecamscript-6">
/* eslint-disable */
 import TopNav from '@/components/common/topNav'
 import Banner from '@/components/goodsCoupon/banner'
 import Mune from '@/components/goodsCoupon/mune'
 import TodayGrapBuy from '@/components/goodsCoupon/todayGrapBuy'
 import SpecialArea from '@/components/goodsCoupon/specialArea'
 import CouponGoodsList from '@/components/goodsCoupon/couponGoodsList'
 import $ from 'jquery'
 export default {
    name: 'goodsCoupon',
    data() {
      return{
        parentCat:"",
        offsetTop:0
      }
    },
    created:function(){

    },
    methods:{
     getClassfiy(param1){
       this.parentCat=param1;
       this.$nextTick(() => {
         $("body").height(2000)
          $('html,body').animate({'scrollTop': this.offsetTop},)


         //console.log(document.body.scrollTop)

       })


     }
    },
    mounted(){
      //$('body').scrollTop(700)
      //console.log(document.get)
      this.offsetTop = this.$refs.offsetTopEle.offsetTop
    },
  components:{
    'topNav':TopNav,
    'banner':Banner,
    'mune':Mune,
    'todayGrapBuy':TodayGrapBuy,
    'specialArea':SpecialArea,
    'couponGoodsList':CouponGoodsList
  }
  }
</script>



// WEBPACK FOOTER //
// src/components/goodsCoupon/goodsCoupon.vue